import { inject } from 'aurelia';
import { IDialogController } from '@aurelia/dialog';

/**
 * Inloggningen räcker inte för nya Control hos stiftelsen (apply-system 0023
 * p4). Säger vilken nivå stiftelsen kräver och vilken man har, och låter en
 * logga in igen på rätt sätt eller avbryta.
 */
@inject(IDialogController)
export class ControlLevelDialog {
  constructor(controller) {
    this.controller = controller;
  }

  activate(model) {
    this.required = (model && model.required) || 'eid';
    this.current = (model && model.current) || '';
  }

  get requiresBankId() {
    return this.required === 'eid';
  }

  get requiresOtp() {
    return this.required === 'otp';
  }

  /** Ett krav på bara lösenord (test) nekas bara när inloggningen saknar nivå. */
  get levelUnknown() {
    return this.required === 'basic';
  }

  get currentKey() {
    if (this.current === 'basic') return 'control_access.level.current_basic';
    if (this.current === 'otp') return 'control_access.level.current_otp';
    return '';
  }

  /** Logga in igen: dialogen stängs med "ok", och appen loggar ut till inloggningen. */
  signInAgain() {
    this.controller.ok(true);
  }

  cancel() {
    this.controller.cancel();
  }
}
